module.exports = __webpack_public_path__ + "img/brandstory_img1.32f704fb.png";